import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		inputRadio_helperText: {
			padding: theme.spacing(0),
		},
		inputRadio_select: {
			color: theme.palette.primary.main,
		},
		inputRadio_unselect: {
			color: theme.palette.grey[500],
		},
		inputRadio_disable: {
			'&$inputRadio_disableEmpty': {
				color: theme.palette.grey[300],
			}
		},
		inputRadio_selectDisable: {
			'&$inputRadio_disableEmpty': {
				color: theme.palette.primary[300],
			}
		},
		inputRadio_disableEmpty: {

		},
		inputRadio_error: {
			color: theme.palette.error.main,
		},
		inputRadio_labelSelect: {
			color: theme.palette.info.main,
		},
		inputRadio_labelUnselect: {
			color: theme.palette.info.main,
		},
		inputRadio_labelDisable: {
			color: theme.palette.info[300],
		},
		inputRadio_labelSelectDisable: {
			color: theme.palette.info[300],
		},
		inputRadio_labelError: {
			color: theme.palette.error.main,
		},
	});
});

export default useStyles;
